import {
  ModuleItemType,
  ModuleTemplateTypeEnum,
} from "@packages/flow-core/module";
import { FlowNodeTypeEnum } from "@packages/flow-core/module/node/constants";
import {
  FlowNodeInputItemType,
  FlowNodeOutputItemType,
} from "@packages/flow-core/module/node/types";

export const generate_init_template_modules = (
  templateId: string
): ModuleItemType[] => {
  return [
    {
      moduleId: templateId,
      templateType: ModuleTemplateTypeEnum.getContent,
      name: "流程模板全局变量",
      description: "流程模板全局变量",
      avatar:
        "https://actstatic.insnail.com/workflow/imgs/module/plugin-input.svg",
      flowType: FlowNodeTypeEnum.templateParam,
      position: { x: 630, y: 520 },
      inputs: [] as FlowNodeInputItemType[],
      outputs: [] as FlowNodeOutputItemType[],
    },
  ];
};
